module.exports = __webpack_public_path__ + "static/8-9e2aa644c1afef5bad3c455b7b42deed.png";